/**
 * Global layout width caps for web (and width-constrained tablet layouts).
 * Use these instead of hardcoded `maxWidth` numbers.
 */

/** Centered page / main sheet column — replaces former 760/720/620/800/520/600 caps. */
export const WEB_MAX_CONTENT_WIDTH = 980;

/** Standard modal, payment sheet, alert/snackbar hosts. */
export const WEB_MODAL_MAX_WIDTH = 640;

/** Compact dialogs (e.g. transfer product). */
export const WEB_COMPACT_MODAL_MAX_WIDTH = 480;

/** Inline snackbar component cap. */
export const WEB_SNACKBAR_MAX_WIDTH = 500;

/** Web drawer / narrow side panel. */
export const WEB_DRAWER_PANEL_MAX_WIDTH = 400;

/** Small about dialog / tight inline cards. */
export const WEB_SMALL_DIALOG_MAX_WIDTH = 360;

/** Product list web thumbnail row. */
export const WEB_PRODUCT_GRID_IMAGE_MAX_WIDTH = 300;

/**
 * Design input to `s()` for the main POS web nav sidebar rail width.
 * Must stay in sync with `WebSidebar` (`components/web/WebSidebar.tsx`).
 */
export const WEB_NAV_SIDEBAR_RAIL_S = 86;
